import {JsonAny} from "../../Types";
import parseISO from "date-fns/parseISO";

export interface VideoComment {
    id: number | string;
    videoId: number;
    /** 氏名 */
    fullName: string;
    text: string;
    commentTimeMillis: number;
    created: Date;
    userId: number | string;
}

export interface VideoCommentChangeSet {
    id: number;
    userId: number;
    text: string;
    commentTimeMillis: number;
    isPrivate: boolean;
    userName?: string;
}

export function parseVideoComment(json: JsonAny): VideoComment {
    return {
        ...json,
        created: parseISO(json.created)
    };
}
